import { CryptoCurrency, Currency } from '@quickbit/qb-design-system';

export enum OrderStatus {
  INITIATED = 'INITIATED',
  ADDRESS_CREATED = 'ADDRESS_CREATED',
  PROCESSING_INTERNAL = 'PROCESSING_INTERNAL',
  PROCESSING_EXTERNAL = 'PROCESSING_EXTERNAL',
  COMPLETE = 'COMPLETE',
  CRYPTO_RECEIVED = 'CRYPTO_RECEIVED',
  CRYPTO_SOLD = 'CRYPTO_SOLD',
  INVALID_AMOUNT = 'INVALID_AMOUNT',
  REFUND_CRYPTO_RECEIVED = 'REFUND_CRYPTO_RECEIVED',
  REFUNDING = 'REFUNDING',
  REFUNDED = 'REFUNDED',
  CANCELLED = 'CANCELLED',
  MANUAL_REFUND_INITIATED = 'MANUAL_REFUND_INITIATED',
  MANUAL_REFUND_IN_PROGRESS = 'MANUAL_REFUND_IN_PROGRESS',
  MANUALLY_REFUNDED = 'MANUALLY_REFUNDED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
}

export interface Order {
  amount: number;
  currency: Currency;
  merchantId: string;
  merchantName: string;
  hideQbBrand: boolean;
  uuid: string;
  createdAt: Date;
  status: OrderStatus;
  redirectUrl?: string;
  failureRedirectUrl?: string;
  refundRedirectUrl?: string;
}

export interface Wallet {
  currency: CryptoCurrency;
}
